import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  increment
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDNBPP_dJd-PcRBQ3nxrC2vdgNzWo3pUp8",
  authDomain: "my-news-portal-9bded.firebaseapp.com",
  projectId: "my-news-portal-9bded",
  storageBucket: "my-news-portal-9bded.appspot.com",
  messagingSenderId: "583009631162",
  appId: "1:583009631162:web:b43a530ce91d7ddee83b83",
  measurementId: "G-GTZSTSGJSF"
};

const app = initializeApp(firebaseConfig);

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache()
});

export const auth = getAuth(app);

export { increment };